import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  fetchAnnounceWithoutAuth,
  fetchPublishedAnnounce,
  fetchPublishedNews,
  getAttachmentNews,
} from 'APIPackage/NewsModule/services/newsApi';
import { INewsResponse } from 'APIPackage/NewsModule/interfaces/INewsResponse';
import { getUserInfo, getUserRoleSysName } from 'AuthPackage/MainModule/selectors/authSelectors';
import { ROUTE_AUTH } from 'CorePackage/MainModule/routes/routes';
import { catalogGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { saveFile } from 'CorePackage/MainModule/common/saveFile';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { rolesDict } from '../constants/rolesDict';
import { getNewsFilterOption, getNewsSort } from '../selectors/newsSelectors';
import { NewActionsEnum } from '../enums/NewActionsEnum';
import { newsGetAttachmentNews, newsGetData, newsSetAnnounce, newsSetData } from '../actions/newsActions';

export function* watchNewsSaga() {
  yield takeEvery(NewActionsEnum.NEWS_INIT_PAGE, newsInitPageSaga);
  yield takeEvery(NewActionsEnum.NEWS_GET_DATA, newsGetDataSaga);
  yield takeEvery(NewActionsEnum.NEWS_GET_ROLES_OPTION, newsGetRolesOptionSaga);
  yield takeEvery(NewActionsEnum.NEWS_GET_ANNOUNCE, newsGetAnnounceSaga);
  yield takeEvery(NewActionsEnum.NEWS_GET_ATTACHMENT_NEWS, newsGetAttachmentNewsSaga);
}

function* newsInitPageSaga() {
  yield put(newsGetData());
}

function* newsGetDataSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const filterOption = getNewsFilterOption(state);
    const roleSysName = getUserRoleSysName(state);
    const sort = getNewsSort(state);
    const data: INewsResponse = yield fetchPublishedNews(sort, 0);

    yield put(
      newsSetData(
        data.list.filter(x =>
          x.roles.some(
            r => (filterOption && filterOption === rolesDict[r].value) || roleSysName === rolesDict[r].value,
          ),
        ),
      ),
    );
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* newsGetRolesOptionSaga() {
  yield put(catalogGet(CommonCatalogsNamesEnum.ROLES));
}

function* newsGetAnnounceSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const isUserLoggedIn = getUserInfo(state) !== undefined;

    if (isUserLoggedIn || window.location.pathname === ROUTE_AUTH) {
      const data: INewsResponse = isUserLoggedIn ? yield fetchPublishedAnnounce() : yield fetchAnnounceWithoutAuth();

      yield put(newsSetAnnounce(isUserLoggedIn ? data.list[0] : data.content[0]));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* newsGetAttachmentNewsSaga(action: ActionType<typeof newsGetAttachmentNews>) {
  function* funcTry() {
    const { file, id } = action.payload;
    const link: string = yield getAttachmentNews(id, file.id);

    saveFile(link, file.name);
  }

  yield sagaWrapper({
    funcTry,
  });
}
